import * as React from "react";
import { Form } from "react-bootstrap";
import OfficeActionRushProcessing from "./OfficeActionRushProcessing";

export default function OfficeActionStep5({ state, onChange, trademarkRushProcessing, validated }) {
  return (
    <div className="question step-6">
      <Form id="TrademarkForm" noValidate validated={validated}>
        <OfficeActionRushProcessing trademarkRushProcessing={trademarkRushProcessing} onChange={onChange} state={state}/>
      </Form>
    </div>
  );
}
